import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';
import * as idpActions from '../actions';

export const SAVE_OVERALL_DEVELOPMENT_REQUEST = 'FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST';
export const SAVE_OVERALL_DEVELOPMENT_SUCCESS = 'FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS';
export const SAVE_OVERALL_DEVELOPMENT_FAILURE = 'FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE';
export const FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST = 'FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST';
export const FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS = 'FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS';
export const FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE = 'FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE';
export const FETCH_OVERALL_DEVELOPMENT_TEMPLATE_REQUEST = 'FETCH_OVERALL_DEVELOPMENT_TEMPLATE_REQUEST';
export const FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS = 'FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS';
export const FETCH_OVERALL_DEVELOPMENT_TEMPLATE_FAILURE = 'FETCH_OVERALL_DEVELOPMENT_TEMPLATE_FAILURE';

const buildSaveOverallDevelopmentUrl = (idpId) => buildUrl(`/student-idps/${idpId}/overall-development-result`);
const buildFetchOverallDevelopmentResultUrl = (idpId) => buildUrl(`/student-idps/${idpId}/overall-development-result`);
const buildFetchOverallDevelopmentTemplateUrl = (idpId) => buildUrl(`/student-idps/${idpId}/overall-development-template`);

export function fetchOverallDevelopmentTemplateIfNeeded(idpId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchOverallDevelopmentTemplateUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchOverallDevelopmentTemplate(idpId));
  };
}

export function fetchOverallDevelopmentResultIfNeeded(idpId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildFetchOverallDevelopmentResultUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchOverallDevelopmentResult(idpId));
  };
}

export function fetchOverallDevelopmentTemplate(idpId) {
  return (dispatch) => {
    const url = buildFetchOverallDevelopmentTemplateUrl(idpId);
    const method = 'GET';

    return dispatch(fetchOverallDevelopmentTemplateRequest()).payload
      .then((response) => dispatch(fetchOverallDevelopmentTemplateSuccess(response)))
      .catch((error) => dispatch(fetchOverallDevelopmentTemplateFailure(error)));

    function fetchOverallDevelopmentTemplateRequest() {
      return ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_TEMPLATE_REQUEST,
        payload: fetch(url),
        url,
        method,
        idpId,
      });
    }

    function fetchOverallDevelopmentTemplateSuccess(templates) {
      return ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS,
        payload: templates,
        url,
        method,
        idpId,
      });
    }

    function fetchOverallDevelopmentTemplateFailure(error) {
      return ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_TEMPLATE_FAILURE,
        error,
        url,
        method,
        idpId,
      });
    }
  };
}

export function fetchOverallDevelopmentResult(idpId) {
  return (dispatch) => {
    const url = buildFetchOverallDevelopmentResultUrl(idpId);
    const method = 'GET';

    return dispatch(fetchOverallDevelopmentResultRequest()).payload
      .then((response) => dispatch(fetchOverallDevelopmentResultSuccess(response)))
      .catch((error) => dispatch(fetchOverallDevelopmentResultFailure(error)));

    function fetchOverallDevelopmentResultRequest() {
      return ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_RESULT_REQUEST,
        payload: fetch(url),
        url,
        method,
        idpId,
      });
    }

    function fetchOverallDevelopmentResultSuccess(results) {
      return ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS,
        payload: results,
        url,
        method,
        idpId,
      });
    }

    function fetchOverallDevelopmentResultFailure(error) {
      return ApiCall.createAction({
        type: FETCH_OVERALL_DEVELOPMENT_RESULT_FAILURE,
        error,
        url,
        method,
        idpId,
      });
    }
  };
}

export function saveOverallDevelopment(idpId, overallDevelopment, groupIdpId) {
  return (dispatch) => {
    const url = buildSaveOverallDevelopmentUrl(idpId);
    const method = 'PUT';
    const request = fetch(url, {
      method, body: JSON.stringify(overallDevelopment),
    });

    return dispatch(saveOverallDevelopmentRequest()).payload
      .then((response) => dispatch(saveOverallDevelopmentSuccess(response)))
      .then(() => dispatch(fetchOverallDevelopmentResult(idpId)))
      .catch((error) => dispatch(saveOverallDevelopmentFailure(error)))
      .then(() => dispatch(idpActions.fetchIndividualDevelopmentPlanList(groupIdpId)));

    function saveOverallDevelopmentRequest() {
      return ApiCall.createAction({
        type: SAVE_OVERALL_DEVELOPMENT_REQUEST,
        payload: request,
        url,
        method,
        idpId,
      });
    }

    function saveOverallDevelopmentSuccess() {
      return ApiCall.createAction({
        type: SAVE_OVERALL_DEVELOPMENT_SUCCESS,
        url,
        method,
        overallDevelopment,
      });
    }

    function saveOverallDevelopmentFailure(error) {
      return ApiCall.createAction({
        type: SAVE_OVERALL_DEVELOPMENT_FAILURE,
        error,
        url,
        method,
        idpId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/actions.js